'use strict';

var novicell = novicell || {};

novicell.navigation = novicell.navigation || new function () {

  let navItems = document.querySelectorAll('.nav-main-list__item-link');
  let timer = null;
  let timerDropdown = null;
  let hoverElement = null;

  this.init = function () {
    if (navItems.length) {
      for (let i = 0; i < navItems.length; i++) {
        let element = navItems[i];
        let elementParent = element.parentNode;
        let dropdown = elementParent.querySelector('.nav-main-list__lists');
        let subItems = elementParent.querySelectorAll('li.nav-main-list__sub-item--title');
        open(element, false, openSelectedDropdowns);
        element.addEventListener('click', function (event) {
          // Disable click on desktop and mobile, and on mobile then open and hide elements
          if (this.parentNode.querySelectorAll('ul').length) {
            event.stopPropagation();
            event.preventDefault();
            // On mobile we can toggle parent menu items, and close all menus where parent is closed
            if (document.body.clientWidth < 992) {
              jQuery('.nav-main-list__item-link').not(element).parent().removeClass('nav-main-list__item--opened');
              jQuery(element).parent().find('li.nav-main-list__sub-item--title').parent().removeClass('nav-main-list__sub-list--opened');
              this.parentNode.classList.toggle('nav-main-list__item--opened');
            }
          }
        });
        // Disable click on mobile and open and hide elements
        for (let x = 0; x < subItems.length; x++) {
          let subItem = subItems[x];
          subItem.addEventListener('click', function(event) {
            if (this.parentNode.querySelectorAll('li.nav-main-list__sub-item:not(.nav-main-list__sub-item--title)').length && document.body.clientWidth < 992) {
              event.stopPropagation();
              event.preventDefault();
              jQuery(subItems).not(subItem).parent().removeClass('nav-main-list__sub-list--opened');
              this.parentNode.classList.toggle('nav-main-list__sub-list--opened');
            }
          });
        }
        element.addEventListener('mouseenter', function () {
          if (checkIfWeAreOnDesktop() && !('ontouchstart' in window)) {
            clearTimeout(timer);
            clearTimeout(timerDropdown);
            if (element === hoverElement) {
              // Do nothing
            } else {
              close('main');
              open(element, false, openSelectedDropdowns);
              hoverElement = element;
            }
          }
        });
        element.addEventListener('touchstart', function () {
          if (checkIfWeAreOnDesktop() && ('ontouchstart' in window)) {
            event.stopPropagation();
            event.preventDefault();
            close('main');
            open(element, true, openSelectedDropdowns);
            clearTimeout(timer);
            clearTimeout(timerDropdown);
          }
        });
        element.addEventListener('mouseleave', function () {
          if (checkIfWeAreOnDesktop()) {
            timer = setTimeout(function () {
              close('main');
            }, 500);
          }
        });
        if (dropdown) {
          dropdown.addEventListener('mouseenter', function () {
            if (checkIfWeAreOnDesktop()) {
              clearTimeout(timer);
            }
          });
          dropdown.addEventListener('mouseleave', function () {
            if (checkIfWeAreOnDesktop()) {
              timerDropdown = setTimeout(function () {
                close('main');
              }, 500);
              clearTimeout(timer);
            }
          });
          dropdown.addEventListener('touchstart', function (event) {
            if (checkIfWeAreOnDesktop() && ('ontouchstart' in window)) {
              event.stopPropagation();
            }
          }, {passive: true});
        }
      }
      document.body.addEventListener('touchstart', function () {
        if (checkIfWeAreOnDesktop() && ('ontouchstart' in window)) {
          jQuery('.nav-main-list__sub-item--title').removeClass('nav-main-list__sub-item--active');
          close('main');
          close('section');
        }
      }, {passive: true});
    }
  };

  function checkIfWeAreOnDesktop() {
    return document.body.clientWidth > 991;
  }

  // Open selected dropdown on desktop
  function openSelectedDropdowns(element) {
    if (!checkIfWeAreOnDesktop()) {
      return;
    }
    let isActive = false;
    let dropdown = element.parentNode.querySelector('.nav-main-list__lists');
    if (dropdown.querySelectorAll('ul.nav-main-list__sub-list').length) {
      element.parentNode.classList.add('nav-main-list__item--desktop-opened');
      let dropdownItems = dropdown.querySelectorAll('ul.nav-main-list__sub-list');
      for (let i = 0; i < dropdownItems.length; i++) {
        let target = dropdownItems[i].querySelector('.nav-main-list__sub-item--title a');
        let section = dropdownItems[i].querySelector('.nav-main-list-section');
        let element = target.parentNode;
        if (element.classList.contains('js-nav-main-list-sub-item-active') && !isActive) {
          close('section');
          openSelectedSection(element);
          jQuery('.nav-main-list__sub-item--title').not(element).removeClass('nav-main-list__sub-item--active');
          element.classList.add('nav-main-list__sub-item--active');
          isActive = true;
        }
        target.addEventListener('click', function(event) {
          if (section.querySelectorAll('li').length && checkIfWeAreOnDesktop()) {
            event.stopPropagation();
            event.preventDefault();
            close('section');
            jQuery('.nav-main-list__sub-item--title').not(element).removeClass('nav-main-list__sub-item--active');
            element.classList.add('nav-main-list__sub-item--active');
            openSelectedSection(element);
          }
        });
      }
    }
  }

  function open(element, touchDevices, callback) {
    if (!touchDevices) {
      hoverintent(element,
        function () {
          callback(element);
        }, function () {});
    } else {
      callback(element);
    }
  }

  function openSelectedSection(element) {
    let section = element.parentNode.querySelector('.nav-main-list-section');
    if (section && section.querySelectorAll('li').length) {
      section.classList.add('nav-main-list-section--active');
      if (!checkIfThereIsSpaceToSection(document.querySelector('.layout-container'), section)) {
        section.classList.add('nav-main-list-section--place-left');
      }
    }
  }

  function close(type) {
    if (type === 'main') {
      jQuery('.nav-main-list__item-link').parent().removeClass('nav-main-list__item--desktop-opened');
    } else {
      let sections = document.querySelectorAll('.nav-main-list-section');
      for (let i = 0; i < sections.length; i++) {
        sections[i].classList.remove('nav-main-list-section--active');
        sections[i].classList.remove('nav-main-list-section--place-left');
      }
    }
  }

  function checkIfThereIsSpaceToSection(parentDiv, childDiv) {
    let parentRect = parentDiv.getBoundingClientRect();
    let childRect = childDiv.getBoundingClientRect();
    return parentRect.left <= childRect.left && parentRect.right >= childRect.right;
  }
}();